import { notification } from 'ant-design-vue';

// 錯誤類型常數
export const ERROR_TYPES = {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    UNPROCESSABLE_ENTITY: 422,
    BAD_REQUEST: 400,
    SERVER_ERROR: 500,
    GATEWAY_ERROR: 502,
    PAYLOAD_TOO_LARGE: 413,
    METHOD_NOT_ALLOWED: 405,
    REQUEST_TIMEOUT: 408,
    CONFLICT: 409,
    TOO_MANY_REQUESTS: 429,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504
};

// 錯誤訊息配置
export const ERROR_MESSAGES = {
    [ERROR_TYPES.UNAUTHORIZED]: {
        message: '未授權訪問',
        description: '請重新登入'
    },
    [ERROR_TYPES.FORBIDDEN]: {
        message: '沒有操作權限',
        description: '目前帳號無法使用此功能或存取此資料'
    },
    [ERROR_TYPES.NOT_FOUND]: {
        message: '找不到資料',
        description: '資料可能已被移除或不存在'
    },
    [ERROR_TYPES.UNPROCESSABLE_ENTITY]: {
        message: '資料驗證失敗',
        description: '請確認填寫內容後再試一次'
    },
    [ERROR_TYPES.BAD_REQUEST]: {
        message: '請求錯誤 400',
        description: '請求格式不正確，請檢查輸入內容'
    },
    [ERROR_TYPES.SERVER_ERROR]: {
        message: '請求錯誤 500',
        description: '伺服器發生錯誤，請聯絡管理員'
    },
    [ERROR_TYPES.GATEWAY_ERROR]: {
        message: '請求錯誤 502',
        description: '伺服器發生錯誤，請聯絡管理員'
    },
    [ERROR_TYPES.PAYLOAD_TOO_LARGE]: {
        message: '請求錯誤 413',
        description: '請求的資源過大'
    },
    [ERROR_TYPES.METHOD_NOT_ALLOWED]: {
        message: '請求錯誤 405',
        description: '不支援的請求方法'
    },
    [ERROR_TYPES.REQUEST_TIMEOUT]: {
        message: '請求錯誤 408',
        description: '請求超時，請稍後重試'
    },
    [ERROR_TYPES.CONFLICT]: {
        message: '請求錯誤 409',
        description: '資源發生衝突，請重試'
    },
    [ERROR_TYPES.TOO_MANY_REQUESTS]: {
        message: '請求錯誤 429',
        description: '請求過於頻繁，請稍後再試'
    },
    [ERROR_TYPES.SERVICE_UNAVAILABLE]: {
        message: '請求錯誤 503',
        description: '服務暫時不可用，請稍後重試'
    },
    [ERROR_TYPES.GATEWAY_TIMEOUT]: {
        message: '請求錯誤 504',
        description: '閘道超時，請稍後重試'
    }
};

// 通用錯誤通知設定
const commonNotificationConfig = {
    duration: 5,
    style: {
        width: '400px'
    }
};

// 錯誤處理器
export const handleHttpError = (error, url = '', method = '') => {
    const status = error.response?.status;

    // 記錄錯誤
    console.error(`${method.toUpperCase()} ${url} API Error:`, error);

    // 特殊錯誤處理
    const isLoginRequest = /\/(?:api\/admin\/)?login$/.test(String(url));

    if (status === ERROR_TYPES.UNAUTHORIZED && !isLoginRequest) {
        // Token 過期或無效，強制登出
        localStorage.removeItem('accessToken');

        notification.warning({
            message: '登入已過期',
            description: '請重新登入',
            duration: 5,
            style: { width: '400px' }
        });

        window.location.href = '/login';
        return Promise.reject(error);
    }

    if (status === ERROR_TYPES.PAYLOAD_TOO_LARGE) {
        return Promise.reject(error);
    }

    // 獲取錯誤配置
    const errorConfig = ERROR_MESSAGES[status] || {
        message: '請求錯誤',
        description: error.message || '發生未知錯誤，請稍後重試'
    };

    const responseMessage = error.response?.data?.message;

    // 登入頁已有 inline 錯誤，避免再跳「無效的憑證」這類全域通知
    if (isLoginRequest) {
        return Promise.reject(error);
    }

    // 顯示錯誤通知
    notification.error({
        ...errorConfig,
        description: responseMessage || errorConfig.description,
        ...commonNotificationConfig
    });

    // 對於伺服器錯誤，返回更詳細的錯誤資訊
    if (
        status === ERROR_TYPES.SERVER_ERROR ||
        status === ERROR_TYPES.GATEWAY_ERROR
    ) {
        return Promise.reject({
            status,
            message: error.response.data?.message || 'Server Error',
            error
        });
    }

    return Promise.reject(error);
};
